import { defineMessages } from 'react-intl';

export default defineMessages({
  backLabel: {
    id: 'Pdp.CartConfirmationModal.backLabel',
    defaultMessage: 'Added to Cart',
  },
  continue: {
    id: 'Pdp.CartConfirmationModal.continue',
    defaultMessage: 'View Cart',
  },
  warrantyTerm: {
    id: 'Pdp.CartConfirmationModal.warrantyTerm',
    defaultMessage: `{count, plural,
      one {Term: 1 Year}
      other {Term: {count} Years}
    }`,
  },
  warrantyProduct: {
    id: 'Pdp.CartConfirmationModal.warrantyProduct',
    defaultMessage: 'Product: {product}',
  },
  addedToCart: {
    id: 'Pdp.CartConfirmationModal.addedToCart',
    defaultMessage: 'Item(s) added to cart',
  }
});
